<template>
  <m-feature-enable-switch feature="rituals" />
</template>

<script lang="ts">
import Vue from 'vue';
import MFeatureEnableSwitch from '@/components/Settings/MSettingsFeatures/MFeatureEnableSwitch';

export default Vue.extend({
  name: 'm-settings-features-rituals',
  components: { MFeatureEnableSwitch },
});
</script>
